import { withStyles } from '@mui/styles'
import { Drawer as MuiDrawer } from '@mui/material'
import { styled } from 'styled-components'
import { onSmallScreen } from 'mixtiles-web-common'

export const BottomDrawer = withStyles({
  paper: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '16px 16px 0 0',
    padding: '51px 0 40px',
    maxHeight: '100%',
  },
})(MuiDrawer)

export const Title = styled.div`
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
  margin-bottom: 10px;

  ${onSmallScreen()} {
    margin-top: 53px;
  }
`

export const Subtitle = styled.div`
  font-size: 18px;
  line-height: 23px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;
`

export const CtaButton = styled.div`
  margin: 40px auto 13px;
`

export const DismissButton = styled.div`
  margin: auto;

  ${onSmallScreen()} {
    margin-bottom: 53px;
  }
`
